'use es6';

import { Links } from '../enums/Links';
import sprocketWhiteImageUrl from 'bender-url!../../assets/sprocket_white.svg';
import { parseHtmlElementFromString } from '../utils/domHelpers';
const sprocketImage = `
  <img
    class="hs-cmsf-branding__icon"
    alt="HubSpot sprocket logo"
    src="${sprocketWhiteImageUrl}"
  />
`;
const buttonLabel = `
  <label id="hs-cmsf-branding__label" class="hs-cmsf-branding__label">
    Built on HubSpot
  </label>`;
const button = `<button
    aria-haspopup="true"
    aria-expanded="false"
    aria-labelledby="hs-cmsf-branding__label"
    aria-owns="hs-cmsf-branding__dropdown"
    class="hs-cmsf-branding__button"
  >
  ${sprocketImage}
  ${buttonLabel}
  </button>
`;
const dropdown = `
  <div
    id="hs-cmsf-branding__dropdown"
    class="hs-cmsf-branding__dropdown hs-cmsf-branding__dropdown--collapsed"
    role="presentation"
  >
    <ul class="hs-cmsf-branding__dropdown-list">
      <li class="hs-cmsf-branding__dropdown-item">
        <a class="hs-cmsf-branding__dropdown-link"
          href="${Links.REPORT_ABUSE}"
          target="_blank"
          rel="noopener">
            Report Abuse
        </a>
      </li>
      <li class="hs-cmsf-branding__dropdown-item">
        <a class="hs-cmsf-branding__dropdown-link"
          href="${Links.CMS_FREE_SIGNUP}"
          target="_blank"
          rel="noopener">
            Get my own free site
        </a>
      </li>
    </ul>
  </div>
`;
const brandingHtmlString = `
  <div id="hs-cmsf-branding" class="hs-cmsf-branding">
    ${button}
    ${dropdown}
  </div>
`;
export const brandingHtmlElement = parseHtmlElementFromString(brandingHtmlString);